(function() {
    angular
        .module('emarket.main.profile')
        .controller('FavoriteController', ['$state', '$log', '$q', '$stateParams', 'Favorite', 'Profile', function($state, $log, $q, $stateParams, Favorite, Profile) {
            var vm = this;
            var type = 'post';
            var favorites = {
                seller: null,
                post: null
            };
            if ($stateParams.type) {
                type = $stateParams.type;
            }
            var getFavorites = function() {
                vm.isLoading = true;
                var promise = $q.resolve();
                if (favorites[type]) {
                    vm.favorites = favorites[type];
                } else {
                    promise = Profile.getFavorites(type).then(function(fav) {
                        vm.favorites = fav;
                        favorites[type] = fav;
                    });
                }
                return promise
                    .then(function() {
                        vm.isLoading = false;
                    })
                    .catch(function(err) {
                        vm.isLoading = false;
                        throw err;
                    });
            };

            getFavorites();
            vm.changeType = function(newType) {
                vm.favorites = [];
                type = newType;
                getFavorites();
            };
            // vm.isLoading = true;
            // vm.isLoading = false;
            // vm.products = favorites.filter(function(favorite) {
            //     return favorite.type === 'post';
            // }).map(function(favorite) {
            //   // HACK: remove map after erick fix issue
            //     favorite.post = favorite.postId;
            //     return favorite;
            // });
            // vm.sellers = favorites.filter(function(favorite) {
            //     return favorite.type === 'seller';
            // });
        }]);
}());
